import { render, staticRenderFns } from "./publicwrapper.vue?vue&type=template&id=ca00f5da&"
import script from "./publicwrapper.vue?vue&type=script&lang=js&"
export * from "./publicwrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports